import {useEffect, useState} from "react";
import RoutingAuth from "./RoutingAuth";
import Cookies from "js-cookie";
import Body from "../components/routing";
import LoadingPage from "../components/general/LoadingPage";
import {ID_TOKEN} from "../conf";
import {useSessionStore} from "../services/storage/session/SessionStorage";

export default function AuthGeneric() {
    const [loading, setLoading] = useState(true);
    const [session, setSession]  = useState<string | null>();
    const data = useSessionStore(state => state.data)

    useEffect(() => {
        const tokenFromCookie = Cookies.get(ID_TOKEN);

        if (tokenFromCookie) {
            setSession(tokenFromCookie)
        } else {
            setSession(null)
            Cookies.remove(ID_TOKEN);
        }
        setLoading(false)
    }, [data]);

    if (loading) {
        return <LoadingPage />;
    }

    if (session) {
        return <Body />;
    }

    return <RoutingAuth />;
}
